import React, { useState, useEffect } from 'react';
import { useGetUser, useSetUser } from '../../context/userContext';
import editUser from '../../api/editUser';

const ContactInfo = () => {
  const user = useGetUser();
  const setUser = useSetUser();
  const [edit, setEdit] = useState(false);
  const [userCopy, setUserCopy] = useState(user);

  useEffect(() => {
    setUserCopy(user);
  }, [user]);

  return (
    <div className="row mycard">
      <div className="col col-12">
        {edit ? <EditInfo userCopy={userCopy} setUserCopy={setUserCopy} user={user} setUser={setUser} setEdit={setEdit} /> : <Info userCopy={userCopy} setEdit={setEdit} />}
      </div>
    </div>
  );
};

export default ContactInfo;

const Info = ({ userCopy, setEdit }) => {
  return (
    <>
      <h2 className="heading">
        <span>Contact details</span>
        <button className="btn btn-sm profile-btn" onClick={() => setEdit(true)}>
          <i className="bi bi-pencil-fill"></i> Edit
        </button>
      </h2>
      <div className="content">
        <div className="main">
          <div className="row">
            <div className="col col-12 col-md-6 px-5">
              <strong>E-mail:</strong> {userCopy.email}
            </div>
            {userCopy.phone && (
              <div className="col col-12 col-md-6 px-5">
                <strong>Phone:</strong> {userCopy.phone}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const EditInfo = ({ userCopy, setUserCopy, user, setUser, setEdit }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    editUser(userCopy, setUser);
    setEdit(false);
  };

  const handleCancel = () => {
    setUserCopy(user);
    setEdit(false);
  };

  return (
    <>
      <h2 className="heading">
        <span>Contact details</span>
        <span></span>
      </h2>
      <div className="content mx-5">
        <div className="main">
          <form className="row g-3" onSubmit={(e) => handleSubmit(e)}>
            <div className="col-12 col-md-6">
              <label htmlFor="inputEmail" className="form-label">
                Email
              </label>
              <input
                readOnly
                disabled
                type="text"
                className="form-control"
                id="inputEmail"
                placeholder="Email"
                value={userCopy.email}
                onChange={(e) =>
                  setUserCopy((prev) => {
                    return { ...prev, email: e.target.value };
                  })
                }
              />
            </div>

            <div className="col-12 col-md-6">
              <label htmlFor="inputPhone" className="form-label">
                Phone
              </label>
              <input
                type="text"
                className="form-control"
                id="inputPhone"
                placeholder="Phone"
                value={userCopy.phone}
                onChange={(e) =>
                  setUserCopy((prev) => {
                    return { ...prev, phone: e.target.value };
                  })
                }
              />
            </div>

            <div className="col-12 text-end">
              <button type="button" className="btn profile-btn inver mb-1" onClick={handleCancel}>
                Cancel
              </button>
              <button type="submit" className="btn profile-btn mb-1 ms-3">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
